import { 
  FETCHING_STORYBOARD_LEAD_SUMMARY, FETCHING_STORYBOARD_LEAD_SUMMARY_SUCCEEDED, FETCHING_STORYBOARD_LEAD_SUMMARY_FAILED,
  FETCHING_STORYBOARD_LEAD_DETAILS, FETCHING_STORYBOARD_LEAD_DETAILS_SUCCEEDED, FETCHING_STORYBOARD_LEAD_DETAILS_FAILED,
  FETCHING_FIRST_CAPTURED_LEAD_DETAILS, FETCHING_FIRST_CAPTURED_LEAD_DETAILS_SUCCEEDED, FETCHING_FIRST_CAPTURED_LEAD_DETAILS_FAILED,
  FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS, FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_SUCCEEDED, FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_FAILED,
  FETCHING_STORYBOARD_LEAD_JOURNEY, FETCHING_STORYBOARD_LEAD_JOURNEY_SUCCEEDED, FETCHING_STORYBOARD_LEAD_JOURNEY_FAILED,
  FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD, FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED, FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_FAILED,
  FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION, FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_SUCCEEDED, FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_FAILED,
  FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD, FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED, FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_FAILED,
  FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION, FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_SUCCEEDED, FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_FAILED,
  FETCHING_ASSET_INTERACTION_FOR_LEAD, FETCHING_ASSET_INTERACTION_FOR_LEAD_SUCCEEDED, FETCHING_ASSET_INTERACTION_FOR_LEAD_FAILED,
  FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD, FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED, FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_FAILED,INVALIDATE_LEADS_DOWNLOAD_DATA,
  FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION, FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_SUCCEEDED, FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_FAILED, INVALIDATE_STORYBOARD_LEAD_DETAILS
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

const STORYBOARD_REPORTS_BASE_URL = `${apiUrl}/api/1.0/storyboard/reports`;
const STORYBOARD_LEAD_REPORTS_BASE_URL = `${apiUrl}/api/1.0/leads/reports`;

/**
 * Fetch storyboard leadDetails
*/
export const fetchingStoryboardLeadDetails = createAction(FETCHING_STORYBOARD_LEAD_DETAILS, (id, request) => {
  return {
    id: id,
    request: request
  }
});

const fetchingStoryboardLeadDetailsSucceeded = createAction(FETCHING_STORYBOARD_LEAD_DETAILS_SUCCEEDED, (id, response) => {
  return {
    id:id,
    response: response
  }
});

const fetchingStoryboardLeadDetailsFailed = createAction(FETCHING_STORYBOARD_LEAD_DETAILS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingStoryboardLeadDetailsSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}?page=0&limit=5 `
  });

  const fetchingStoryboardLeadDetailsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingStoryboardLeadDetailsAPI);
    if (response) {

      yield put(fetchingStoryboardLeadDetailsSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingStoryboardLeadDetailsFailed(request.storyboard, error));
  }
}

/**
 * Fetch Lead Reports Summary
*/
export const fetchStoryboardLeadReportSummary = createAction(FETCHING_STORYBOARD_LEAD_SUMMARY, (id) => {
  return {
    id: id,
  }
});

const fetchStoryboardLeadReportSummarySucceeded = createAction(FETCHING_STORYBOARD_LEAD_SUMMARY_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchStoryboardLeadReportSummaryFailed = createAction(FETCHING_STORYBOARD_LEAD_SUMMARY_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingLeadSummarySaga(action) {
  const { id } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `storyboard/${id}/summary`
  });

  const fetchingLeadSummaryAPI = () => {
    return axios.post(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchingLeadSummaryAPI);
    if (response) {

      yield put(fetchStoryboardLeadReportSummarySucceeded(id, response));
    }
  } catch (error) {
    yield put(fetchStoryboardLeadReportSummaryFailed(id, error));
  }
}

/**
 * Fetch First Captured leadDetails
*/
export const fetchingFirstCapturedLeads = createAction(FETCHING_FIRST_CAPTURED_LEAD_DETAILS, (id, request) => {
  return {
    id: id,
    request: request
  }
});

const fetchingFirstCapturedLeadsSucceeded = createAction(FETCHING_FIRST_CAPTURED_LEAD_DETAILS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingFirstCapturedLeadsFailed = createAction(FETCHING_FIRST_CAPTURED_LEAD_DETAILS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingFirstCapturedLeadsSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/initial`
  });

  const fetchFirstCapturedLeadsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchFirstCapturedLeadsAPI);
    if (response) {

      yield put(fetchingFirstCapturedLeadsSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingFirstCapturedLeadsFailed(request.storyboard, error));
  }
}

/**
 * Fetch Latest Campaign leadDetails
*/
export const fetchingLatestCampaignLeads = createAction(FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS, (id, request) => {
  return {
    id: id,
    request: request
  }
});

const fetchingLatestCampaignLeadsSucceeded = createAction(FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingLatestCampaignLeadsFailed = createAction(FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingLatestCampaignLeadsSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/latest`
  });

  const fetchingLatestCampaignLeadsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingLatestCampaignLeadsAPI);
    if (response) {

      yield put(fetchingLatestCampaignLeadsSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingLatestCampaignLeadsFailed(request.storyboard, error));
  }
}

/**
 * Fetch Leads Journey
*/
export const fetchingLeadsJourney = createAction(FETCHING_STORYBOARD_LEAD_JOURNEY, (id, request, page, limit) => {
  return {
    id: id,
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingLeadsJourneySucceeded = createAction(FETCHING_STORYBOARD_LEAD_JOURNEY_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingLeadsJourneyFailed = createAction(FETCHING_STORYBOARD_LEAD_JOURNEY_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingLeadsJourneySaga(action) {
  const { id, request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/journey?page=${page}&limit=${limit}`
  });

  const fetchLeadsJourneyAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchLeadsJourneyAPI);
    if (response) {
      yield put(fetchingLeadsJourneySucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingLeadsJourneyFailed(request.storyboard, error));
  }
}

/**
 * Fetch Interactive Page Interaction For Lead
*/
export const fetchingInteractivePageLeadInteraction = createAction(FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD, (id, request, page, limit) => {
  return {
    id: id,
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingInteractivePageLeadInteractionSucceeded = createAction(FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingInteractivePageLeadInteractionFailed = createAction(FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingInteractivePageLeadInteractionSaga(action) {
  const { id, request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/interactive/views?page=${page}&limit=${limit}`
  });

  const fetchInteractivePageLeadInteractionAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchInteractivePageLeadInteractionAPI);
    if (response) {

      yield put(fetchingInteractivePageLeadInteractionSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingInteractivePageLeadInteractionFailed(request.storyboard, error));
  }
}

/**
 * Fetch Charts for Interactive Page Lead Interaction
*/
export const fetchingLeadInteractionChartForInteractivePage = createAction(FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION, (id, request, page, limit) => {
  return {
    id: id,
    request: request, 
    page: page,
    limit: limit
  }
});

const fetchingLeadInteractionChartForInteractivePageSucceeded = createAction(FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingLeadInteractionChartForInteractivePageFailed = createAction(FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingLeadInteractionChartForInteractivePageSaga(action) {
  const { id, request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/interactive/views?page=${page}&limit=${limit}`
  });

  const fetchLeadInteractionChartForInteractivePageAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchLeadInteractionChartForInteractivePageAPI);
    if (response) {

      yield put(fetchingLeadInteractionChartForInteractivePageSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingLeadInteractionChartForInteractivePageFailed(request.storyboard, error));
  }
}

/**
 * Fetch Landing Page Interaction For Lead
*/
export const fetchingLandingPageLeadInteraction = createAction(FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD, (id, request, page, limit) => {
  return {
    id: id,
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingLandingPageLeadInteractionSucceeded = createAction(FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingLandingPageLeadInteractionFailed = createAction(FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingLandingPageLeadInteractionSaga(action) {
  const { id, request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/landing/views?page=${page}&limit=${limit}`
  });

  const fetchLandingPageLeadInteractionAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchLandingPageLeadInteractionAPI);
    if (response) {

      yield put(fetchingLandingPageLeadInteractionSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingLandingPageLeadInteractionFailed(request.storyboard, error));
  }
}

/**
 * Fetch Charts for Landing Page Lead Interaction
*/
export const fetchingLeadInteractionChartForLandingPage = createAction(FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION, (id, request, page, limit) => {
  return {
    id: id,
    request: request, 
    page: page,
    limit: limit
  }
});

const fetchingLeadInteractionChartForLandingPageSucceeded = createAction(FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingLeadInteractionChartForLandingPageFailed = createAction(FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingLeadInteractionChartForLandingPageSaga(action) {
  const { id, request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/landing/views?page=${page}&limit=${limit}`
  });

  const fetchLeadInteractionChartForLandingPageAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchLeadInteractionChartForLandingPageAPI);
    if (response) {

      yield put(fetchingLeadInteractionChartForLandingPageSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingLeadInteractionChartForLandingPageFailed(request.storyboard, error));
  }
}

/**
 * Fetch Assets Interaction For Lead
*/
export const fetchingAssetInteraction = createAction(FETCHING_ASSET_INTERACTION_FOR_LEAD, (id, request, page, limit) => {
  return {
    id: id,
    request: request, 
    page: page,
    limit: limit
  }
});

const fetchingAssetInteractionSucceeded = createAction(FETCHING_ASSET_INTERACTION_FOR_LEAD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingAssetInteractionFailed = createAction(FETCHING_ASSET_INTERACTION_FOR_LEAD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingAssetInteractionSaga(action) {
  const { id, request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/assets/views?page=${page}&limit=${limit}`
  });

  const fetchAssetInteractionAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchAssetInteractionAPI);
    if (response) {

      yield put(fetchingAssetInteractionSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingAssetInteractionFailed(request.storyboard, error));
  }
}

/**
 * Fetch Charts for Assets Lead Interaction
*/
export const fetchingLeadInteractionChartForAsset = createAction(FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION, (id, request, page, limit) => {
  return {
    id: id,
    request: request, 
    page: page,
    limit: limit
  }
});

const fetchingLeadInteractionChartForAssetSucceeded = createAction(FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingLeadInteractionChartForAssetFailed = createAction(FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingLeadInteractionChartForAssetSaga(action) {
  const { id, request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_LEAD_REPORTS_BASE_URL, {
    path: `/${id}/assets/views?page=${page}&limit=${limit}`
  });

  const fetchingLeadInteractionChartForAssetAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingLeadInteractionChartForAssetAPI);
    if (response) {

      yield put(fetchingLeadInteractionChartForAssetSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingLeadInteractionChartForAssetFailed(request.storyboard, error));
  }
}

/**
 * Fetch Reports Data For Download
*/
export const fetchLeadReportsDataForDownload = createAction(FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchLeadReportsDataForDownloadSucceeded = createAction(FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchLeadReportsDataForDownloadFailed = createAction(FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* downloadLeadReportsSaga(action) {
  const { request, page, limit } = action.payload;

  try {
    let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
      path: `/metrics/leads?page=${page}&limit=${limit}`
    });

    const fetchLeadReportsDataForDownloadAPI = () => {
      return axios.post(url, request).then(response => response.data);
    }

    var response = yield call(fetchLeadReportsDataForDownloadAPI);

    if (response) {
      const { records, ...pagination } = response;
      const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;

      var nextPage = page + 1;

      if (hasMoreItems) {
        yield put(fetchLeadReportsDataForDownload(request, nextPage, limit));
      }

      yield put(fetchLeadReportsDataForDownloadSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchLeadReportsDataForDownloadFailed(request.storyboard, error));
  }
}

/**
 * Invalidate Download Data
*/
export const invalidateLeadsDownloadData = createAction(INVALIDATE_LEADS_DOWNLOAD_DATA);
export const invalidateStoryboardLeadDetails = createAction(INVALIDATE_STORYBOARD_LEAD_DETAILS);

export default function* leadsSaga() {
  yield takeEvery(FETCHING_STORYBOARD_LEAD_DETAILS, fetchingStoryboardLeadDetailsSaga);
  yield takeEvery(FETCHING_STORYBOARD_LEAD_SUMMARY, fetchingLeadSummarySaga);
  yield takeEvery(FETCHING_FIRST_CAPTURED_LEAD_DETAILS, fetchingFirstCapturedLeadsSaga);
  yield takeEvery(FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS, fetchingLatestCampaignLeadsSaga);
  yield takeEvery(FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD, fetchingInteractivePageLeadInteractionSaga);
  yield takeEvery(FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION, fetchingLeadInteractionChartForInteractivePageSaga);
  yield takeEvery(FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD, fetchingLandingPageLeadInteractionSaga);
  yield takeEvery(FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION, fetchingLeadInteractionChartForLandingPageSaga);
  yield takeEvery(FETCHING_ASSET_INTERACTION_FOR_LEAD, fetchingAssetInteractionSaga);
  yield takeEvery(FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION, fetchingLeadInteractionChartForAssetSaga);
  yield takeEvery(FETCHING_STORYBOARD_LEAD_JOURNEY, fetchingLeadsJourneySaga);
  yield takeEvery(FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD, downloadLeadReportsSaga);
}